// Generated by CoffeeScript 1.6.3
(function() {
  rjm.model.CohortField = Backbone.RelationalModel.extend({
    initialize: function(options) {
      if (!options || !options.hasOwnProperty("id") || !options.hasOwnProperty("name") || !options.hasOwnProperty("canCountMembers") || !options.hasOwnProperty("clientId")) {
        throw "InvalidConstructorArgs - CohortField";
      }
      this.set({
        minTime: null
      });
    },
    fetchMinTime: function() {
      var _this = this;
      this.set({
        minTime: null
      });
      return $.when($.ajax({
        type: "GET",
        url: $.url('/chartBuilder/' + this.get("clientId") + '/cohortFieldMinTimestamp/' + this.get("id")),
        processData: false,
        contentType: 'application/json'
      })).done(function(minTime) {
        if (minTime === null) {
          _this.set({
            minTime: -1
          });
          return;
        }
        _this.set({
          minTime: minTime * 1000
        });
      });
    },
    hasMembers: function() {
      return this.get("canCountMembers") && this.get("localTableName") !== this.get("remoteTableName");
    }
  });

  rjm.model.CohortFieldCollection = Backbone.Collection.extend({
    model: rjm.model.CohortField,
    initialize: function(args, options) {
      this.clientId = options.clientId;
    },
    url: function() {
      return $.url("/client/" + this.clientId + "/trend/" + this.trendId + "/cohortFields");
    },
    setTrendId: function(trendId) {
      this.trendId = trendId;
      return this;
    }
  });

}).call(this);
